/**
 * Branding API Service - Stub for TDD RED phase (TASK-064)
 *
 * API client functions for organization branding management.
 * Minimal stub so test mocks can resolve the import.
 */
import apiClient from './client';
import type { OrganizationBranding } from '../../types/branding';

export const brandingApi = {
  /**
   * Get organization branding settings
   */
  get: async (): Promise<OrganizationBranding> => {
    const response = await apiClient.get<OrganizationBranding>(
      '/api/v1/branding/'
    );
    return response.data;
  },

  /**
   * Update organization branding settings
   */
  update: async (
    data: Partial<OrganizationBranding>
  ): Promise<OrganizationBranding> => {
    const response = await apiClient.put<OrganizationBranding>(
      '/api/v1/branding/',
      data
    );
    return response.data;
  },

  /**
   * Upload organization logo
   */
  uploadLogo: async (file: File): Promise<{ logo_url: string }> => {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await apiClient.post<{ logo_url: string }>(
      '/api/v1/branding/upload-logo/',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },
};

export default brandingApi;
